import { AnimatePresence, motion } from 'framer-motion';
import { useTheme } from 'styled-components';

import { EmptyStateCard } from 'src/app/components/Elements/Card/EmptyStateCard';
import { MedicationCard } from 'src/app/components/Models/Medication/MedicationCard';
import { PendingMedication } from 'src/app/components/Pages/Medications/PendingMedication';
import type { HomePrescriptionItem } from 'src/app/types';

interface AnimatedMedicationProps {
  hasMultiplePatients: boolean;
  prescriptionItems: HomePrescriptionItem[];
  isPendingTransfers?: boolean;
  showPendingText?: boolean;
  showNoActiveMedications: boolean;
}

export const AnimatedMedications = ({
  hasMultiplePatients,
  prescriptionItems,
  isPendingTransfers = false,
  showPendingText,
  showNoActiveMedications,
}: AnimatedMedicationProps) => {
  const theme = useTheme();

  if (showNoActiveMedications && !isPendingTransfers && prescriptionItems.length === 0) {
    return (
      <EmptyStateCard height={8} text="No active medications." textStyle="grayNormal" addTopMarginToAllCards={false} />
    );
  }

  return (
    <AnimatePresence>
      {prescriptionItems.map((item, index) => {
        return (
          <motion.div key={item.id} style={{ marginTop: index === 0 ? 'none' : theme.space.s4 }}>
            {isPendingTransfers ? (
              <PendingMedication homePrescriptionItem={item} showPendingText={showPendingText} />
            ) : (
              <MedicationCard
                addTopMarginToAllCards={false}
                isArchivedSection={false}
                homeScreenItem={item}
                hasMultiplePatients={hasMultiplePatients}
                showMenuActions={true}
                showRefillCount={true}
                showInstructions={false}
                goToMedDetailsOnMedNameClick={true}
                withLegacyAnimations={false}
              />
            )}
          </motion.div>
        );
      })}
    </AnimatePresence>
  );
};
